<template>
  <div id="new_list_outer">
    <ul class="list-group" v-if="itemList != null">
      <li class="list-group-item" v-for="(item, index) in itemList" :key="'offic_news_' + index">
        <a class="news-item" :href="itemSrc(item)"
           target="_blank">
<!--          <div>{{item.actionTitle}}</div>-->
          <hot-label :title="item.actionTitle" :flag="item.flag" :flagInvalidTIme="item.flagInvalidTIme"></hot-label>
          <div>{{itemDate(item)}}</div>
        </a>
      </li>
    </ul>
    <div v-else-if="showNoDataNotice" style="min-height: 200px;font-size: 1.5rem;padding-top: 120px;color: #666;text-align: center;">
      暂无数据！
    </div>

    <div style="padding-right: 30px;">
      <bottom-paginator
        v-bind:current="pageIndex"
        v-bind:total="totalPage"
        v-bind:paginator-type="1"
        v-on:itemClicked="paginatorClicked"
      />
    </div>
  </div>
</template>

<script>
  import BottomPaginator from "../BottomPaginator";
  import GlobalInstance from "../../js/shba";
  import HotLabel from "../common/HotLabel";
  export default {
    name: "AssociationsNewsList",
    props: {
      tagId: {
        type: Number,
        value: 0,
      },
      tagName: {
        type: String,
        value: ''
      }
    },
    components: {
      BottomPaginator,
      HotLabel
    },
    watch: {
      tagId(newVal, oldVal) {

        if (newVal != oldVal) {
          this.refreshData();
        }
      },
    },
    data() {
      return {
        title: '新闻列表',
        itemList: null,
        pageIndex: 1,
        size: 10,
        count: 0,
        isLoading: false,
        showNoDataNotice: false,
      }
    },
    computed: {
      totalPage() {
        let total = 0;
        if (this.count == 0) {
          total = 0;
        } else {
          total = Math.ceil(this.count / this.size);
        }
        return total;
      }
    },
    mounted() {
      this.loadData();
    },
    methods: {
      paginatorClicked(event) {
        let index = event.index;
        this.pageIndex = index;
        this.loadData();
      },

      refreshData() {
        this.pageIndex = 1;
        this.count = 0;
        this.loadData();
      },

      loadData() {
        if (this.isLoading) {
          return;
        }
        let pageIndex = this.pageIndex;
        let params = {
          pageIndex,
          size: this.size,
          tag: this.tagName,
        };
        this.isLoading = true;
        let _this = this;
        this.$store.state.http.ajax.otherAssociationData(params,function (data) {
          _this.isLoading = false;
          _this.showNoDataNotice = false;
          // console.log(data);
          let code = data.code;
          if (code == 0) {
            let newList = data.data;
            _this.count = data.count;

            if (newList.length > 0) {
              _this.itemList = newList;
            } else {
              _this.itemList = null;
              _this.showNoDataNotice = true;
            }
            return;
          }

          _this.$toast('请求失败！');

        },function (data) {
          _this.isLoading = false;
          _this.showNoDataNotice = false;
          _this.$toast('请求失败，请重试！');
        });
      },
      itemSrc(item) {
        let web = item.newsUrl;
        if (web != null && web.length > 0) {
          return web;
        }
        return '/news/0301/0/'  + item.id;
      },

      itemDate(item) {
        return this.$moment(item.createTime).format('yyyy.MM.DD');
      }
    }
  }
</script>

<style scoped>

  #new_list_outer {
    width: 100%;
    padding-left: 15px;
    padding-right: 15px;
  }

  #new_list_outer li {
    border: none;
    padding-left: 0;
    padding-right: 0;
  }

  #new_list_outer ul {
    padding-top: 30px;
    min-height: 200px;
  }

  #new_list_outer a {
    display: flex;
    flex-direction: row;
    width: 100%;
    flex-wrap: nowrap;
    justify-content: space-between;
    align-items: center;
    color: #666;
    font-size: 15px;
    text-decoration: none;
  }

  #new_list_outer a > div:first-child {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
  }

  #new_list_outer a:hover {
    color: #333;
  }

</style>




// WEBPACK FOOTER //
// src/components/other-associations/AssociationsNewsList.vue